export const LAYOUTS_RESET_STATE = 'LAYOUTS_RESET_STATE';
export const LAYOUTS_CURRENT_ITEM = 'LAYOUTS_CURRENT_ITEM';

export const LAYOUTS_REQUEST_LOADING = 'LAYOUTS_REQUEST_LOADING';
export const LAYOUTS_REQUEST_SUCCESS = 'LAYOUTS_REQUEST_SUCCESS';
export const LAYOUTS_REQUEST_FAILED = 'LAYOUTS_REQUEST_FAILED';

export const LAYOUTS_CURRENT_ACTION = 'LAYOUTS_CURRENT_ACTION';
export const LAYOUTS_RESET_ACTION = 'LAYOUTS_RESET_ACTION';